import { render, staticRenderFns } from "./CamioViewer.vue?vue&type=template&id=683384c4&lang=html&"
import script from "./CamioViewer.vue?vue&type=script&lang=ts&"
export * from "./CamioViewer.vue?vue&type=script&lang=ts&"
import style0 from "./CamioViewer.vue?vue&type=style&index=0&id=683384c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports